import { render, staticRenderFns } from "./AttachmentComponent.vue?vue&type=template&id=25657a69&"
import script from "./AttachmentComponent.vue?vue&type=script&lang=js&"
export * from "./AttachmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports